import React from 'react'

export default function FootBar() {
    return (
        <div id="FootBar">
            <em>Created by Kai Yu Leung. 2022</em>
        </div>
    )
}
